import React from 'react';
import classNames from 'classnames';

import css from './LayoutWrapperMain.css';

const LayoutWrapperMain = props => {
  const { className, rootClassName, children } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes} role="main">
      {children}
    </div>
  );
};

export default LayoutWrapperMain;
